declare const grecaptcha: {
  ready(callback: () => void): void;
  execute(siteKey: string, action: { action: string }): PromiseLike<string>;
};

export const callRecaptcha = (): Promise<string> => {
  return new Promise((resolve) => {
    if (!grecaptcha) {
      console.log('grecaptcha not available');
      resolve('');
      return;
    }

    grecaptcha.ready(() => {
      try {
        grecaptcha.execute(process.env.REACT_APP_RECAPTCHA_KEY || '', { action: 'submit' }).then(
          (token: string) => resolve(token),
          (error) => {
            console.log('Error executing recaptcha:', error);
            resolve('');
          }
        );
      } catch (error) {
        console.log('Error with recaptcha execution:', error);
        resolve('');
      }
    });
  });
};
